import Rest from './rest';

const RESOURCE = "/a/article";

export default {
    get: function (data) {
        return Rest.get(RESOURCE, {params: data});
    },
    save(data) {
        return Rest.post(RESOURCE, data);
    },
    update(id, data) {
        return Rest.put(`${RESOURCE}/${id}`, data);
    },
    updateStatus(id, data) {
        return Rest.put(`${RESOURCE}/${id}/status`, data);
    },
    delete(id) {
        return Rest.delete(`${RESOURCE}/${id}`);
    },
};



// WEBPACK FOOTER //
// ./src/services/ArticleService.js